import dayjs from 'dayjs';

import { TableWithForm, TitledContainer } from 'components';

import { useGetHeaders, useTableSearchParams, useUserRole } from 'hooks';

import { IssuancesTable } from './IssuancesTable';
import { columns, fields, handleTransactionsTableChange } from './lib';

export const Transactions = () => {
  const headers = useGetHeaders();
  const { isAdmin } = useUserRole();

  const tableFormParams = fields(isAdmin).map(({ name }) => name) as string[];

  const { setSearchParams, defaultTableParams, formInitialValues } = useTableSearchParams({ tableFormParams });

  const {
    statuses,
    createdTo,
    createdFrom,
    ...rest
  } = formInitialValues;

  const states = statuses ? statuses.split(',') : [];
  const submittedDates = createdTo && createdFrom ? [dayjs(createdFrom), dayjs(createdTo)] : [dayjs().subtract(30, 'day'), dayjs().endOf('day')];

  return (
    <TitledContainer title='Transactions'>
      <TableWithForm
        // table
        withResetButton
        horizontalScroll
        id='transactions-table'
        size='small'
        columns={columns(isAdmin)}
        onTableChange={handleTransactionsTableChange(headers, setSearchParams)}
        formInitialValues={{ ...rest, statuses: states, submittedDates }}
        defaultTableParams={defaultTableParams}
        expandable={{
          rowExpandable: ({ issuances }) => !!issuances?.length,
          expandedRowRender: ({ id, snapId, issuances }) => (
            <IssuancesTable
              snapId={snapId}
              transactionId={id}
              dataSource={issuances}
            />
          ),
        }}
        // form
        fields={fields(isAdmin)}
        labelCol={{ span: 0 }}
        wrapperCol={{ span: 24 }}
      />
    </TitledContainer>
  );
};
